//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "InvoiceSectionPanel",
    props: {
        salesOrderId: { type: [Number, String], default: "" },
        // ชื่อลูกค้าจาก quotation ที่เลือก (แสดงอย่างเดียว)
        customerName: { type: String, default: "" },
        price: { type: [Number, String], default: "" },
        // สกุลเงินจาก quotation ที่เลือก (แสดงอย่างเดียว)
        currency: { type: String, default: "" },
        salesOrderList: { type: Array, default: () => [] },
        invoiceList: { type: Array, default: () => [] },
        invoiceStatusList: { type: Array, default: () => ["Draft", "Requested", "Invoiced", "Paid"] },
        sectionLabel: { type: String, default: "E · การเงิน & สถานะ Invoice" },
        readonly: { type: Boolean, default: false },
    },
    computed: {
        hasInvoice() {
            return Array.isArray(this.invoiceList) && this.invoiceList.length > 0;
        },
    },
    methods: {
        onSelectSO(value) {
            // ส่งทั้ง value (สำหรับ .sync) และ object เต็มของ quotation ที่เลือก
            // ให้ parent เอาไปคำนวณ price / เก็บ status เองได้ ไม่ต้องไปค้นซ้ำ
            this.$emit("update:salesOrderId", value);
            const selected = this.salesOrderList.find((item) => item.quotation_id === value) || null;
            this.$emit("select-so", selected);
        },
    },
};
